var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollectbookTag01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 16,
    viewBox: "0 0 43 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_collectbook_tag_01",
    clipPath: "url(#clip0_2496_32276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.727273C3.98338 0.727273 0.727273 3.98338 0.727273 8C0.727273 12.0166 3.98338 15.2727 8 15.2727H34.1818C38.1984 15.2727 41.4545 12.0166 41.4545 8C41.4545 3.98338 38.1984 0.727273 34.1818 0.727273H8ZM0 8C0 3.58172 3.58172 0 8 0H34.1818C38.6001 0 42.1818 3.58172 42.1818 8C42.1818 12.4183 38.6001 16 34.1818 16H8C3.58172 16 0 12.4183 0 8Z",
    fill: "#938F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4069 10.5641V11.4782H8.19043V10.5641H11.7309V9.09797H9.16431V6.15875H14.3396V5.04071H9.15024V4.1477H15.433V7.03418H10.2683V8.1944H15.6404V9.09797H12.8278V10.5641H16.4069ZM20.8821 4.4149V8.5917H17.3381V4.4149H20.8821ZM18.3789 7.74086H19.8485V5.26924H18.3789V7.74086ZM18.6567 12.3466V9.37923H19.7605V11.4501H24.9184V12.3466H18.6567ZM21.6978 9.91715V3.70822H22.7245V6.11655H23.6245V3.54297H24.6757V10.216H23.6245V7.02364H22.7245V9.91715H21.6978ZM30.4343 4.76297C30.4308 6.15523 31.7914 7.54749 33.6724 7.87798L33.1765 8.79913C31.6683 8.48621 30.4343 7.57562 29.8506 6.36618C29.26 7.56508 28.026 8.47919 26.5246 8.79913L26.0395 7.87798C27.8923 7.54047 29.2529 6.14819 29.26 4.76297V4.10199H30.4343V4.76297ZM25.7899 11.3762V10.4621H34.0064V11.3762H25.7899Z",
    fill: "#938F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2496_32276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1818,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollectbookTag01);
export default __webpack_public_path__ + "static/media/icon_collectbook_tag_01.d0cfb78d6f5bb6a8d97cef90b4a25ad5.svg";
export { ForwardRef as ReactComponent };